import React from 'react';

function LoveSvg() {
  return (
    <svg
      width="74"
      height="66"
      viewBox="0 0 74 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M65.3704 9.12762C63.7456 7.50202 61.8164 6.21247 59.693 5.33266C57.5697 4.45284 55.2938 4 52.9954 4C50.697 4 48.4211 4.45284 46.2977 5.33266C44.1743 6.21247 42.2451 7.50202 40.6203 9.12762L37.2482 12.4997L33.876 9.12762C30.594 5.84555 26.1425 4.0017 21.501 4.0017C16.8594 4.0017 12.408 5.84555 9.12592 9.12762C5.84385 12.4097 4 16.8611 4 21.5027C4 26.1442 5.84385 30.5957 9.12592 33.8777L12.498 37.2499L37.2482 62L61.9983 37.2499L65.3704 33.8777C66.996 32.2529 68.2856 30.3237 69.1654 28.2003C70.0452 26.077 70.498 23.8011 70.498 21.5027C70.498 19.2043 70.0452 16.9284 69.1654 14.805C68.2856 12.6817 66.996 10.7525 65.3704 9.12762Z"
        stroke="#171717"
        strokeWidth="6.3625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LoveSvg;
